export const ProModal = ({ onUnlock, onClose, onRestore }) => {
  return (
    <div className="absolute inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="pro-overlay">
      <div className="rounded-3xl p-5 w-[340px] shadow-2xl border border-amber-400/20 text-center overflow-y-auto max-h-[90vh]"
        style={{ background: 'linear-gradient(160deg, #0f0c29 0%, #1a1a3e 50%, #24243e 100%)' }}
      >
        {/* Crown & Title */}
        <div className="text-4xl mb-1" style={{ filter: 'drop-shadow(0 2px 8px rgba(251,191,36,0.5))' }}>&#x1F451;</div>
        <h2 className="text-2xl font-bold text-amber-400 mb-0.5" style={{ fontFamily: 'Fredoka, sans-serif' }}>Mimi Fly Pro</h2>
        <p className="text-white/40 text-xs mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Unlock the full experience</p>

        {/* Features */}
        <div className="space-y-1.5 text-left mb-5">
          {[
            { text: 'Unlock ALL 4 characters', icon: '🎭' },
            { text: 'Play ALL 7 levels', icon: '🌍' },
            { text: 'Play Online', icon: '🏁' },
            { text: 'Ad-free experience', icon: '✨' },
            { text: 'Customize intro & outro', icon: '🎬' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2.5 px-3 py-2 rounded-xl"
              style={{ background: 'rgba(255,255,255,0.04)' }}>
              <span className="text-base">{item.icon}</span>
              <span className="text-white/80 text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={() => onUnlock('pro')}
          className="w-full py-3.5 rounded-xl text-base font-bold text-slate-900 transition-all hover:scale-105 active:scale-95"
          style={{
            background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
            fontFamily: 'Fredoka, sans-serif',
            boxShadow: '0 4px 20px rgba(251,191,36,0.3)',
          }}
          data-testid="pro-unlock"
        >
          Upgrade to Pro
        </button>

        <p className="text-white/30 text-[10px] mt-2 leading-tight" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Subscription managed via App Store or Google Play
        </p>

        {/* Restore Purchase */}
        <button
          onClick={onRestore}
          className="text-amber-400/60 text-xs mt-3 hover:text-amber-400 transition-colors block mx-auto underline underline-offset-2"
          style={{ fontFamily: 'Nunito, sans-serif' }}
          data-testid="restore-purchase"
        >
          Restore Purchase
        </button>

        {/* Close */}
        <button
          onClick={onClose}
          className="text-white/30 text-xs mt-2 hover:text-white/50 transition-colors block mx-auto"
          style={{ fontFamily: 'Nunito, sans-serif' }}
          data-testid="pro-close"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
};
